var getCouponData = function getCouponData(tags) {
  return tags == null ? void 0 : tags.find(function (tag) {
    return tag.type === 'coupon';
  });
};
export default getCouponData;